module.exports = __webpack_public_path__ + "img/player-icon.e3129a9c.svg";